
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setSubmitMessage('Por favor ingresa tu correo electrónico');
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const response = await fetch('https://readdy.ai/api/public/form/submit/newsletter-segurosconleo', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          email: email,
        }),
      });

      if (response.ok) {
        setSubmitMessage('¡Gracias por suscribirte! Pronto recibirás nuestros consejos.');
        setEmail('');
      } else {
        setSubmitMessage('Hubo un error. Por favor intenta de nuevo.');
      }
    } catch (error) {
      setSubmitMessage('Hubo un error. Por favor intenta de nuevo.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1a2332] text-white">
      {/* Sección superior con logo y descripción */}
      <div className="max-w-7xl mx-auto px-8 py-16">
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h3 className="text-4xl font-bold mb-4">SegurosconLeo</h3>
            <p className="text-white/70 text-lg leading-relaxed">
              Protegiendo el futuro financiero de las familias mexicanas con educación, estrategia y compromiso.
            </p>
          </div>
          <div className="flex justify-end">
            <a
              href="http://wa.me/524443289285"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#14B8A6] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#14B8A6]/90 transition-all cursor-pointer whitespace-nowrap inline-block"
            >
              Agenda tu Consulta Gratuita
            </a>
          </div>
        </div>

        {/* Línea divisoria */}
        <div className="border-t border-white/10 mb-12"></div>

        {/* Grid de columnas */}
        <div className="grid md:grid-cols-3 gap-12">
          {/* Columna 1 - Navegación */}
          <div className="space-y-6">
            <h4 className="text-white text-lg font-semibold leading-tight">Navegación</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('hero')}
                  className="text-white/70 hover:text-white transition-colors cursor-pointer"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('metodo-fep')}
                  className="text-white/70 hover:text-white transition-colors cursor-pointer"
                >
                  Método FEP
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('sobre-mi')}
                  className="text-white/70 hover:text-white transition-colors cursor-pointer"
                >
                  Sobre Mí
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('testimonios')}
                  className="text-white/70 hover:text-white transition-colors cursor-pointer"
                >
                  Testimonios
                </button>
              </li>
            </ul>
          </div>

          {/* Columna 2 - Contacto */}
          <div className="space-y-6">
            <h4 className="text-white text-lg font-semibold leading-tight">Contacto</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-phone-line text-xl"></i>
                </div>
                <div>
                  <p className="text-white/70">+52 444 328 9285</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-map-pin-line text-xl"></i>
                </div>
                <div>
                  <p className="text-white/70">San Luis Potosí, México</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Columna 3 - Redes Sociales */}
          <div className="space-y-6">
            <h4 className="text-white text-lg font-semibold leading-tight">Síguenos</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://www.instagram.com/segurosconleo/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white/70 hover:text-white transition-colors"
                >
                  <i className="ri-instagram-line text-xl"></i>
                  <span>Instagram</span>
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/segurosconleo?rdid=lIJXyOTo5u3DwF8w&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1WTVcDHStY%2F%3Fref%3D1#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white/70 hover:text-white transition-colors"
                >
                  <i className="ri-facebook-line text-xl"></i>
                  <span>Facebook</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Sección inferior - Copyright */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/50 text-sm">
              © 2025 SegurosconLeo. Todos los derechos reservados.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/50 hover:text-white text-sm transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
